import React, { useState, useEffect } from 'react';
import { Link, useParams, useNavigate } from "react-router-dom";
import { baseUrl } from '../components/BaseUrl';
import { paystackUrl } from '../components/PaystackUrl';
import { Spinner } from "react-bootstrap";
import axios from 'axios';
import moment from 'moment';
import Swal from "sweetalert2";
import '../App.css';

const QuizDescription = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState('');
  const [enrolling, setEnrolling] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();

  // Check authentication on component mount
  useEffect(() => {
    const token = localStorage.getItem("codefussion-login-token");
    if (token === null) {
      navigate("/login");
    } else {
      setIsAuthenticated(true);
      getQuiz();
    }
  }, [navigate]);

  // Function to get the correct quiz route based on title
  const getQuizRoute = (quizTitle) => {
    const title = quizTitle.toLowerCase();
    
    // Define route mappings
    const routeMap = {
      'html': '/html-quiz',
      'css': '/css-quiz',
      'php': '/php-quiz', 
      'javascript': '/javascript-quiz',
      'jquery': '/jquery-quiz',
      'react': '/react-quiz',
      'node js': '/node-js-quiz',
      'node js': '/node-js-quiz', // Make sure this matches your route definition
      'nodejs': '/node-js-quiz',  // Add alternative spelling
      'node': '/node-js-quiz',    // Add another alternative
      'digital foundation': '/digital-foundation'
    };

    // Find the matching route or use a default
    for (const [key, route] of Object.entries(routeMap)) {
      if (title.includes(key)) {
        return `${route}/${quizTitle}`;
      }
    }

    // Default fallback route
    return `/quiz/${quizTitle}`;
  };

  const checkEmailVerification = (value) => {
    const token = localStorage.getItem("codefussion-login-token");
    setLoading(true);
    const userData = {
      email: localStorage.getItem("codefussion-student-email"),
    };
    axios.post(`${baseUrl}check-email-verification.php`, userData,
      { headers:
        { Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: token
        }
      }).then((response) => {
        if(response.data.status === 0){
          setLoading(false);
          Swal.fire({
            title: "Error!",
            text: "An error occurred. Please try again later.",
            icon: "error",
            confirmButtonText: "OK",
            backdrop: `
            rgba(143, 70, 0, 0.3)
            url("")
            left top
            no-repeat
          `
          });
        }else{
          // Check if response.data is an array before mapping
          if (Array.isArray(response.data)) {
            response.data.forEach((item) => {
              setStatus(item.verify_status);
              if(item.verify_status === "1"){
                checkQuiz(value)
              }else{
                Swal.fire({
                  title: "Email Not Verified",
                  text: "Please verify your email to continue",
                  icon: "error",
                  confirmButtonText: "OK",
                  backdrop: `
                  rgba(143, 70, 0, 0.3)
                  url("")
                  left top
                  no-repeat
                `
                });
              }
            });
          }
          setLoading(false);
        }
      }).catch((error) => {
        setLoading(false);
        Swal.fire({
          title: "Error!",
          text: "An error occurred while checking email verification.",
          icon: "error",
          confirmButtonText: "OK",
        });
      });
  };

  const getQuiz = () => {
    const token = localStorage.getItem("codefussion-login-token");
    setLoading(true);
    const userData = {
      id: id
    };
    
    // console.log("Fetching quiz with ID:", id);
    
    axios.post(`${baseUrl}get-quiz-by-id.php`, userData,
      { headers:
        { Accept: "application/json",
          "Content-Type": "application/json",
          // Authorization: token
        }
      }).then((response) => {
        // console.log("Quiz API Response:", response);
        
        // Check if response exists and has data
        if (!response || !response.data) {
          setLoading(false);
          Swal.fire({
            title: "Error!",
            text: "No response from server.",
            icon: "error",
            confirmButtonText: "OK",
          });
          return;
        }

        if(response.data.status === 0){
          setLoading(false);
          Swal.fire({
            title: "Error!",
            text: "An error occurred. Please try again later.",
            icon: "error",
            confirmButtonText: "OK",
          });
        } else {
          // Check if data is array or object and set accordingly
          if (Array.isArray(response.data)) {
            setData(response.data);
          } else if (typeof response.data === 'object') {
            // If it's a single object, wrap it in an array
            setData([response.data]);
          } else {
            setData([]);
          }
          setLoading(false);
        }
      }).catch((error) => {
        console.error("Quiz fetch error:", error);
        setLoading(false);
        Swal.fire({
          title: "Network Error!",
          text: "Failed to fetch quiz. Please check your connection.",
          icon: "error",
          confirmButtonText: "OK",
        });
      });
  };

  const checkQuiz = (title) => {
    const token = localStorage.getItem("codefussion-login-token");
    setLoading(true);
    setDisabled(true);
    const userData = {
      email: localStorage.getItem("codefussion-student-email"),
      id: title
    };
    axios.post(`${baseUrl}check-quiz-date.php`, userData,
      { headers:
        { Accept: "application/json",
          "Content-Type": "application/json",
          // Authorization: token
        }
      }).then((response) => {
        let date = "";
        let today = moment().startOf('day');
        
        // Check if response data exists and is iterable
        if (response.data && Array.isArray(response.data)) {
          response.data.forEach(item => {
            date = item.date_created;
          });
        }
        
        var createdDate = moment(date, "YYYY-MM-DD").startOf('day');
        var diff = today.diff(createdDate, 'days');
        
        if(diff >= 30 || date === ""){
          checkEnrollment(title);
          setLoading(false);
          setDisabled(false);
        } else {
          setLoading(false);
          setDisabled(false);
          Swal.fire({
            title: "Already taken",
            text: `You have already taken this quiz.\n\nYou can retry in  ${30-diff} days.`,
            icon: "error",
            confirmButtonText: "OK",
            backdrop: `
            rgba(143, 70, 0, 0.3)
            url("")
            left top
            no-repeat
          `
          });
        }
      }).catch((error) => {
        setLoading(false);
        setDisabled(false);
        Swal.fire({
          title: "Error!",
          text: "Failed to check quiz status.",
          icon: "error",
          confirmButtonText: "OK",
        });
      });
  };

  const checkEnrollment = (title) => {
    const token = localStorage.getItem("codefussion-login-token");
    
    // Safely set duration from data
    if (data && data.length > 0) {
      data.forEach((item) => {
        localStorage.setItem("duration", item.quiz_duration);
      });
    }
    
    setEnrolling(true);
    setDisabled(true);
    const userData = {
      email: localStorage.getItem("codefussion-student-email"),
    };
    
    axios.post(`${baseUrl}check-enrollment.php`, userData,
      { headers:
        { Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: token
        }
      }).then((response) => {
        setEnrolling(false);
        setDisabled(false);
        
        if(!response.data) {
          Swal.fire({
            title: "Error!",
            text: "No response from enrollment check.",
            icon: "error",
            confirmButtonText: "OK",
          });
          return;
        }

        if(response.data.status === 0){
          Swal.fire({
            title: "You don't have an active track.",
            text: "Would you like to enrol?",
            icon: "warning",
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: "Enrol now",
            denyButtonText: `Enrol later`,
            backdrop: `
            rgba(143, 70, 0, 0.3)
            url("")
            left top
            no-repeat
          `
          }).then((result) => {
            if (result.isConfirmed) {
              navigate("/tracks");
            } else if (result.isDenied) {
              const quizRoute = getQuizRoute(title);
              navigate(quizRoute);
            }
          });
        } else {
          const quizRoute = getQuizRoute(title);
          navigate(quizRoute);
        }
      }).catch((error) => {
        setEnrolling(false);
        setDisabled(false);
        Swal.fire({
          title: "Error!",
          text: "Failed to check enrollment status.",
          icon: "error",
          confirmButtonText: "OK",
        });
      });
  };

  const showQuiz = () => {
    // Check if data exists and is not empty
    if (!data || data.length === 0) {
      return (
        <div className='mt-4 Schem'>
          <h1>Quiz Not Found</h1>
          <p>The requested quiz could not be loaded. Please try again later.</p>
        </div>
      );
    }

    return data.map((item, index) => {
      // Use index as fallback key if no id
      const key = item.id || index;
      
      return(
        <div className='mt-4 Schem' key={key}>
          <h1 className='text-left'>{item.quiz_title || "Untitled Quiz"}</h1>
          <p className='text-dark' >{item.quiz_description || "No description available."}</p>

          <h3>Duration</h3>
          <p>{item.quiz_duration ? `${item.quiz_duration} Minutes` : "Not specified"} </p>

          <h3>Objectives</h3>
          <ol>
            <li>{item.objective_one || "Objective not specified"}</li>
            <li>{item.objective_two || "Objective not specified"}</li>
            <li>{item.objective_three || "Objective not specified"}</li>
          </ol>

          <h3>Features</h3>
          <ol>
            <li>{item.feature_one || "Feature not specified"}</li>
            <li>{item.feature_two || "Feature not specified"}</li>
            <li>{item.feature_three || "Feature not specified"}</li>
            <li>{item.feature_four || "Feature not specified"}</li>
          </ol>

          {localStorage.getItem("codefussion-subscription-status") === "active" ?
            <button style={{ background: '#0153d6', color: '#fff', border: 0}} disabled={disabled} onClick={()=>checkEmailVerification(item.quiz_title)} className="btn btn-primary col-md-3 col-lg-3 col-sm-12" >
              {enrolling ? (
                <Spinner animation="border" variant="light" size="sm" />
              ) : (
                "Start Assessment"
              )}
            </button> :
            <Link to={`/subscription-plans`}>
              <button className="btn btn-primary col-md-3 col-lg-3 col-sm-12" type="button">Subscribe</button>
            </Link>
          }
        </div>
      );
    });
  };

  // Don't render anything if not authenticated (will redirect)
  if (!isAuthenticated) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{height: "100vh"}}>
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  return (
    <div>
      <div className="p-4 mb-4" >
        <Link to="/quiz"><i className="fas fa-circle-xmark float-end text-danger exit"></i></Link>
      </div>
      {loading ?  
        <center>
          <div className="loader-wrapper">
            <div className="loader">
              <div className="loader loader-inner"></div>
            </div>
          </div>
        </center> :
        <div className="container">
          {showQuiz()}
        </div>
      }
    </div>
  );
};

export default QuizDescription;